/**
 * ---------------------------------------------------
 * Prestige v11対応: ギフトラッピング 1:1 紐付けスクリプト (最終仕上げ版)
 * ---------------------------------------------------
 */

/**
 * 1. 商品ページ：ラッピングの同時追加とカートへの遷移
 */
document.addEventListener('submit', function(event) {
  const form = event.target;
  
  if (!form.matches('form[action*="/cart/add"]')) return;

  const wrappingSelect = document.getElementById('wrapping-select') || form.querySelector('select[name="properties[ラッピング]"]');
  if (!wrappingSelect) return;

  // ★未選択のままカート追加を押された場合のブロック処理
  if (wrappingSelect.value === "" || wrappingSelect.value === "選択してください") {
    // 送信をストップ
    event.preventDefault();
    event.stopImmediatePropagation();

    // プルダウンを赤枠にして目立たせる
    wrappingSelect.style.border = "2px solid #fe3e3e";
    
    // アラートを出してお知らせ
    setTimeout(() => { 
      alert("ラッピングサービス（有料）※ を選択してください。"); 
    }, 100);

    // ユーザーが選択したら赤枠を元に戻す
    wrappingSelect.addEventListener('change', function() {
        wrappingSelect.style.border = "";
    }, { once: true });

    return;
  }

  // ラッピング「あり」の場合のみ独自処理を発動
  if (wrappingSelect.value === 'あり') {

    if (!window.wrappingVariantId) {
       console.error("[ラッピング機能] エラー: window.wrappingVariantId が見つかりません。");
       return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    const formData = new FormData(form);
    let mainVariantId = formData.get('id');
    let quantity = formData.get('quantity') || 1;

    if (!mainVariantId) {
       const idInput = form.querySelector('input[name="id"]') || document.querySelector(`input[name="id"][form="${form.id}"]`);
       mainVariantId = idInput ? idInput.value : null;
    }
    if (!mainVariantId) return;

    const bundleId = Date.now().toString(); 

    let mainProperties = {
      'ID': bundleId, 
      'ラッピング': 'あり'
    };
    
    for (let [key, value] of formData.entries()) {
      if (key.startsWith('properties[') && key !== 'properties[ラッピング]' && !key.includes('ID') && !key.includes('紐付けID') && !key.includes('_bundle_id')) {
        const propName = key.replace('properties[', '').replace(']', '');
        mainProperties[propName] = value;
      }
    }

    const mainItem = {
      id: mainVariantId,
      quantity: quantity,
      properties: mainProperties
    };

    const wrappingItem = {
      id: window.wrappingVariantId,
      quantity: quantity,
      properties: {
        'ID': bundleId, 
        '_is_wrapping': 'true' 
      }
    };

    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [mainItem, wrappingItem] })
    })
    .then(response => {
      if(!response.ok) throw new Error('カート追加エラー');
      return response.json();
    })
    .then(data => {
      window.location.href = window.Shopify.routes.root + 'cart';
    })
    .catch(error => {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
      console.error('[ラッピング機能] 同時追加エラー:', error);
    });
  }
}, true); 


/**
 * 2. カート画面：連動削除・数量更新 ＋ 操作ボタンの非表示化
 */
function syncCartItems(cartData) {
  if (!cartData || !cartData.items) return;

  const wrappingItems = cartData.items.filter(item => item.properties && item.properties['ID'] && item.properties['_is_wrapping']);
  
  wrappingItems.forEach(wrapItem => {
    document.querySelectorAll(`a[href*="${wrapItem.key}"], button[data-line-key="${wrapItem.key}"]`).forEach(el => {
      el.style.setProperty('display', 'none', 'important');
    });
    document.querySelectorAll(`input[name="updates[${wrapItem.key}]"], input[data-line-key="${wrapItem.key}"]`).forEach(input => {
      const quantityContainer = input.closest('line-item-quantity, .quantity-selector, quantity-selector');
      if (quantityContainer) quantityContainer.style.setProperty('display', 'none', 'important');
      input.style.setProperty('display', 'none', 'important');
    });
  });

  if (window.isSyncingCart) return;

  let updates = {};
  let needsUpdate = false;

  const mainItems = cartData.items.filter(item => item.properties && item.properties['ID'] && !item.properties['_is_wrapping']);

  wrappingItems.forEach(wrapItem => {
    const bundleId = wrapItem.properties['ID'];
    const parentItem = mainItems.find(item => item.properties['ID'] === bundleId);

    if (!parentItem) {
      updates[wrapItem.key] = 0;
      needsUpdate = true;
    } else if (parentItem.quantity !== wrapItem.quantity) {
      updates[wrapItem.key] = parentItem.quantity;
      needsUpdate = true;
    }
  });

  mainItems.forEach(mainItem => {
    const bundleId = mainItem.properties['ID'];
    const wrapItem = wrappingItems.find(item => item.properties['ID'] === bundleId);

    if (!wrapItem) {
      if (updates[mainItem.key] !== 0) {
         updates[mainItem.key] = 0;
         needsUpdate = true;
      }
    }
  });

  if (needsUpdate) {
    window.isSyncingCart = true;
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
    .then(response => response.json())
    .then(newCart => {
      window.location.reload();
    })
    .catch(error => {
      console.error("[ラッピング機能] 連動更新エラー:", error);
      window.isSyncingCart = false;
    });
  }
}

document.documentElement.addEventListener('cart:change', function(event) {
  syncCartItems(event.detail.cart);
});

document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname.endsWith('/cart')) {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(cartData => {
         syncCartItems(cartData);
      });
  }
});